module.exports = __webpack_public_path__ + "img/person2.96ab89b2.png";